module.exports = __webpack_public_path__ + "img/lpdh2x.1e7665a5.png";